<template>
  <b-tabs>
    <b-tab title="Notificações">
      <lista-notificacao />
    </b-tab>
    <b-tab title="Grupos de Notificação">
      <lista-grupo-notificacao active />
    </b-tab>
  </b-tabs>
</template>

<script>
export default {
  name: 'NotificacaoConfiguracao',
  components: {
    ListaNotificacao: () => import('@/app-modulo/comuns/notificacao/shared/components/listas/ListaNotificacao.vue'),
    ListaGrupoNotificacao: () => import('@/app-modulo/comuns/notificacao/shared/components/listas/ListaGrupoNotificacao.vue'),
  },
}
</script>
